// @ts-nocheck aafaf6c6
import localModeActionTypes from './localModeActionTypes';
const { SET_PUSHING_STATUS } = localModeActionTypes;
const setPushingStatus = (pushingStatus) => ({
  type: SET_PUSHING_STATUS,
  pushingStatus,
});

export default setPushingStatus;
